// extracted by mini-css-extract-plugin
export var closeButton = "_j7-1";
export var closeX = "_j7-3";
export var container = "_j7-0";
export var image = "_j7-2";